// @flow
import { DecorationIcon } from './DecorationIcon';

type Props = {
  corporate?: boolean,
  reseller?: boolean,
};

export function ContactDecorationIcons({
  corporate,
  reseller,
}: Props): React.MixedElement {
  return (
    <>
      {corporate && <DecorationIcon kind="corporate" />}

      {reseller && <DecorationIcon kind="reseller" />}
    </>
  );
}
